import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ModuleService } from 'app/services/module.service';
import { ReplaySubject, Subject } from 'rxjs';
import { Feature } from './interfaces/feature.interface';
import { Module } from './interfaces/module.interface';

@Injectable()
export class Modules {

    public changes: Subject<Array<Module>> = new ReplaySubject<Array<Module>>();
    
    private _modules: Array<Module> = new Array();
    private _lastRouterEvent: NavigationEnd;
    
    public currentChange$: Subject<Module> = new ReplaySubject<Module>();
    private _current: Module;
    get current(): Module {
        return this._current;
    }

    constructor(private _router: Router, private _moduleService: ModuleService) {
        this.init();
        this._onRouterEvent();
    }

    public async init() {
        const modules = await this._moduleService.loadConfig();
        if (modules) this.fromJSON(modules);

        this._loadLastRouteConfig();
    }

    public fromJSON(modules: Array<Module>) {
        this._validate(modules);
        this._modules.push(...modules);
        this.changes.next(this._modules);
    }

    public isActive(routerLink: string) {
        return this._current.routerLink === routerLink;
    }

    private _validate(modules: Module[]) {
        if (!modules || modules.length == 0)
            return;

        modules.forEach(this._validateModules.bind(this));
    }

    private _validateModules(module: Module) {
        if (!module.features || module.features.length == 0)
            return;

        const {name, features, routerLink} = module;

        if(!name || !features || !routerLink) {
            throw `A definição do módulo ${name} não foi registrada corretamente.`;
        }

        this._parseFeatureEnabledFlag(module);
        this._currentChange(module.default ? module : this._current);
        module.features.forEach(this._validateFeatures.bind(this));
    }

    private _validateFeatures(feature: Feature) {
        if (!feature.childrens || feature.childrens.length == 0)
            return;
        
        const {id, label, childrens} = feature;
        
        if(!id || !label || !childrens) {
            throw `A definição da feature ${id} não foi registrada corretamente.`;
        }

        this._parseFeatureEnabledFlag(feature);
        feature.childrens.forEach(this._validateFeatures.bind(this));
    }

    private _onRouterEvent() {
        this._router.events.subscribe(event => {
            if(event instanceof NavigationEnd) {
                this._lastRouterEvent = event;
                this._currentChange(this._modules.find(module => event.url.indexOf(module.routerLink) !== -1) || this._current);        
            }
        })
    }

    private _currentChange(module: Module) {
        this._current = module;
        this.currentChange$.next(this._current);
    }

    private _parseFeatureEnabledFlag(feature: Feature | Module) {
        feature.enabled = feature.enabled === undefined ? true : feature.enabled;
    }

    private _loadLastRouteConfig() {
        if(this._lastRouterEvent)
            this._currentChange(this._modules.find(module => this._lastRouterEvent.url.indexOf(module.routerLink) !== -1) || this._current);        
    }
}
